import React, { useEffect, useState, useRef } from 'react'
import { useParams } from 'react-router-dom'
import {useDispatch, useSelector  } from 'react-redux'
import { getTransactionById } from '../../../redux_store/transactions/transaction_thunk';
import { LOADING } from '../../../redux_store/actionTypes';
import LoadingModal from '../../templates/modals/LoadingModal';
import moment from 'moment';
import { convertFromPesewasToCedis, displayFile, getAmount } from '../../../utils';

const TransactionBreakdownPage = () => {
  const { id } = useParams();
  const userPicRef = useRef(null);
  const dispatch = useDispatch();
  const { transactions, status } = useSelector((state)=>state.transaction)
  const [transaction, setTransaction] = useState({});

  useEffect(()=>{
    if(id){
      dispatch(getTransactionById({id}))
    }
    // eslint-disable-next-line
  }, [id])

  useEffect(()=>{
    if(!Array.isArray(transactions)){
      if(transaction.user){
        displayFile(transaction.user.profile_pic, userPicRef.current);
      }
      setTransaction(transactions)
    }
    // eslint-disable-next-line
  }, [transactions]);

  console.log('transaction:: ', transaction);

  return (
    <div className="grid grid-cols-6 bg-white gap-10 p-5 rounded-md shadow-md">
      {status === LOADING && <LoadingModal message={'Loading data...'} />}
      <div className='col-span-2 space-y-4'>
        <p className=' text-gray-600 text-sm font-semibold'>User Profile Picture</p>
        <div ref={userPicRef} className='border border-blue-300 h-1/3 rounded-lg shadow-md'></div>
      </div>
      <div className="grid grid-cols-2 col-span-4">
        <div className="overflow-hidden sm:rounded-lg col-span-4">
          {transaction.user ?
            <>
              <div className="px-4 py-2 border border-blue-300 sm:px-6">
                <h3 className="text-md leading-6 font-semibold text-blue-600">
                  User Info
                </h3>
              </div>
              <div>
                <dl>
                  <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                    <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                      Surname
                    </dt>
                    <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                      {transaction.user.surname}
                    </dt>
                  </div>
                  <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                    <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                      Other names
                    </dt>
                    <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                      {transaction.user.other_names}
                    </dt>
                  </div>
                  <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                    <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                      Role
                    </dt>
                    <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                      {transaction.user.role}
                    </dt>
                  </div>
                  <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                    <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                      Email Address
                    </dt>
                    <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                      {transaction.user.email || 'N/A'}
                    </dt>
                  </div>
                  <div className="bg-white sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                    <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                      Phone Number
                    </dt>
                    <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                      {transaction.user.phone_number}
                    </dt>
                  </div>
                </dl>
              </div>
            </>
            : <p className=' text-gray-600 text-sm'>User not available</p>}

          {transaction.trip && 
            <>
            <div className="px-4 py-2 mt-10 border border-blue-300 sm:px-6">
              <h3 className="text-md leading-6 font-semibold text-blue-600">
                Trip Info
              </h3>
            </div>
            <div>
              <dl>
                <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    Status
                  </dt>
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  {transaction.trip.status === 'PENDING' ? 
                      <p className='bg-yellow-500 inline-block text-xs rounded-lg py-1 px-2 text-gray-100 animate-bounce'>pending</p>: 
                    transaction.trip.status === 'TO PICKUP' ?  
                      <p className='bg-slate-500 inline-block text-xs rounded-lg py-1 px-2 text-gray-100'>to pickup location</p>:
                    transaction.trip.status === 'AT PICKUP' ?  
                      <p className='bg-slate-800 inline-block text-xs rounded-lg py-1 px-2 text-gray-100'>at pickup location</p>:
                    transaction.trip.status === 'TO DESTINATION' ?  
                      <p className=' bg-blue-500 inline-block text-xs rounded-lg py-1 px-2 text-gray-100'>to destination</p>:
                    transaction.trip.status === 'AT DESTINATION' ?  
                      <p className='bg-zinc-500 inline-block text-xs rounded-lg py-1 px-2 text-gray-100'>at destination</p>:
                    transaction.trip.status === 'COMPLETED' ?  
                      <p className='bg-green-500 inline-block text-xs rounded-lg py-1 px-2 text-gray-100'>completed</p>:
                    transaction.trip.status === 'CANCELLED' ?  
                      <p className='bg-red-500 inline-block text-xs rounded-lg py-1 px-2 text-gray-100'>cancelled</p>:
                    transaction.trip.status === 'RATED' ?  
                      <p className=' bg-orange-500 inline-block text-xs rounded-lg py-1 px-2 text-gray-100'>rated</p>:<p>Unknown</p>
                    }
                  </dt>
                </div>
                <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    Origin
                  </dt>
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    {transaction.trip.origin_description}
                  </dt>
                </div>
                <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    Destination
                  </dt>
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    {transaction.trip.destination_description}
                  </dt>
                </div>
                <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    Customer Trip Rating
                  </dt>
                  <dt className="text-sm flex my-auto col-span-2 leading-5 font-medium text-gray-500">
                    {/* {getUserStars(transaction.trip.rating.rate)} */}
                  </dt>
                </div>
                <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    Driver Trip Rating
                  </dt>
                  <dt className="text-sm flex my-auto col-span-2 leading-5 font-medium text-gray-500">
                    {/* {getUserStars(transaction.trip.rating.rate)} */}
                  </dt>
                </div>
                <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    Payment Method
                  </dt>
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    {transaction.trip.payment_method}
                  </dt>
                </div>
                <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    Time Requested
                  </dt>
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    {moment(transaction.trip.createdAt).format('LLLL')}
                  </dt>
                </div>
                <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    Time Started
                  </dt>
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    {transaction.trip.trip_start_time ? moment(transaction.trip.trip_start_time).format('LLLL'): 'N/A'}
                  </dt>
                </div>
                <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    Time Ended
                  </dt>
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    {transaction.trip.trip_end_time ? moment(transaction.trip.trip_end_time).format('LLLL'): 'N/A'}
                  </dt>
                </div>
                <div className="bg-white sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    Actual Total Cost
                  </dt>
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    {transaction.trip.actual_total_cost ? `GHC ${convertFromPesewasToCedis(transaction.trip.actual_total_cost).toFixed(2)}`: 'N/A'}
                  </dt>
                </div>
                <div className="bg-white sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    Discount
                  </dt>
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    {transaction.trip.discounted_price ? `GHC ${convertFromPesewasToCedis(transaction.trip.discounted_price).toFixed(2)} (${transaction.trip.promo_code})`: 'No discount'}
                  </dt>
                </div>
                <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    Final Cost
                  </dt>
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    {transaction.trip.final_total_cost ? `GHC ${(convertFromPesewasToCedis(transaction.trip.final_total_cost)).toFixed(2)}`: 'N/A'}
                  </dt>
                </div>
              </dl>
            </div>
            </>          
          }
          <div className="px-4 py-2 border border-blue-300 sm:px-6">
            <h3 className="text-md leading-6 font-semibold text-blue-600">
              Transaction Info
            </h3>
          </div>
          <div>
            <dl>
              <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  Transaction status
                </dt>
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                <p className='bg-zinc-500 inline-block text-xs rounded-lg py-1 px-2 text-gray-100'>{transaction.status && transaction.status.toLowerCase()}</p>
                </dt>
              </div>
              <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  Transaction amount
                </dt>
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  GHC {getAmount(transaction).toFixed(2)}
                </dt>
              </div>
              <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  Transaction Description
                </dt>
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  {transaction.description}
                </dt>
              </div>
              <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  Balance before transaction
                </dt>
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  GHC {transaction.previous_credit_amount && convertFromPesewasToCedis(transaction.previous_credit_amount).toFixed(2)}
                </dt>
              </div>
              <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  Balance after transaction
                </dt>
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  GHC {transaction.current_credit_amount && convertFromPesewasToCedis(transaction.current_credit_amount).toFixed(2)}
                </dt>
              </div>
            </dl>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TransactionBreakdownPage